import { Http } from "@Services";
import { AccountModel } from "@Interfaces";

const login = async (
    data: AccountModel.PostLoginRequest
): Promise<AccountModel.PostLoginResponse> => {
    let response: AccountModel.PostLoginResponse;

    try {
        response = await Http.Request<AccountModel.PostLoginResponse>({
            method: "POST",
            url: "/account/login",
            data,
        });
    } catch (error) {
        throw Error(error.statusText);
    }
    return response;
};

export default login;
